/**
 * `/v1/meta` query state → the footer's three-way operational phase.
 *
 * Extracted from `router-root.tsx` so the mapping is unit-testable: the shell
 * is excluded from the web coverage gate ("covered by E2E"), and the only E2E
 * that exercises this path is HTTP-project-gated, so inline it was verified by
 * nothing. Keeping loading distinct from error distinct from no-snapshot is
 * the §6.7 operational-state contract — collapsing any two of them is the
 * defect `staleness-banner.spec.ts` exists to prevent.
 */
import type { MetaPhase } from '@/components/chrome/app-footer';

/**
 * `hasData` wins over `isError`: TanStack Query keeps the last good payload
 * through a background refetch failure, and a footer that flips to
 * "unavailable" while still rendering that payload's numbers would contradict
 * the screen around it.
 */
export function metaPhaseOf(isError: boolean, hasData: boolean): MetaPhase {
  if (hasData) return 'ready';
  if (isError) return 'error';
  return 'loading';
}
